// mixin.js
import Vue from 'vue';
import Component from 'vue-class-component';

// You can declare a mixin as the same style as components.
@Component
export default class LuxtagMixin extends Vue {
  public routerGoTo(path: string, isReplaceMethod = false) {
    if (isReplaceMethod) {
      this.$router.replace(path);
    } else {
      this.$router.push(path);
    }
  }
}
